/**
 *  Import all Store Finder pre-built templates (for stores)
 */
import { template as templateDefault } from './templates/template-simple';
import { template as templatePdpCnc1h } from './templates/template-click-n-collect';
import { template as templatePdpNoCnc1h } from './templates/template-no-click-n-collect';
import { template as templatePLP } from './templates/template-plp';
import { template as templateStoreLocator } from './templates/template-store-locator';

/**
 *  Export a function that returns a pre-built template (for stores)
 */
export const getTemplate = name => {
  switch (name) {
    case 'simple':
      return templateDefault;
    case 'pdp-cnc1h':
      return templatePdpCnc1h;
    case 'pdp-nocnc1h':
      return templatePdpNoCnc1h;
    case 'plp':
      return templatePLP;
    case 'store-locator':
      return templateStoreLocator;
    default:
      return templateDefault;
  }
};



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/templates.js